import { useState, FormEvent } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d4udb5ecd4084g36bsfg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-72 h-72 bg-amber-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-amber-600 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="w-20 h-20 bg-amber-500/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-6 border border-amber-500/30">
          <i className="ri-mail-line text-4xl text-amber-400"></i>
        </div>
        
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Stay Inspired
        </h2>
        <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto">
          Get exclusive updates on new creations, special offers, and behind-the-scenes stories from our workshop
        </p>

        <form onSubmit={handleSubmit} className="max-w-lg mx-auto" data-readdy-form>
          <div className="flex flex-col sm:flex-row gap-4">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email address"
              className="flex-1 px-6 py-4 rounded-xl text-sm bg-white/10 backdrop-blur-sm border border-white/20 text-white placeholder-gray-400 focus:ring-2 focus:ring-amber-500 focus:border-transparent focus:outline-none transition-all"
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="bg-amber-500 text-white px-8 py-4 rounded-xl text-sm font-semibold hover:bg-amber-600 transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              {isSubmitting ? 'Subscribing...' : 'Subscribe'}
              {!isSubmitting && <i className="ri-arrow-right-line ml-2"></i>}
            </button>
          </div>

          {submitStatus === 'success' && (
            <div className="mt-4 p-4 bg-green-500/20 border border-green-500/50 rounded-xl backdrop-blur-sm">
              <p className="text-sm text-green-300 font-medium">✓ Thank you for subscribing!</p>
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="mt-4 p-4 bg-red-500/20 border border-red-500/50 rounded-xl backdrop-blur-sm">
              <p className="text-sm text-red-300 font-medium">✗ Something went wrong. Please try again.</p>
            </div>
          )}
        </form>

        <p className="text-xs text-gray-400 mt-6">
          We respect your privacy. Unsubscribe anytime.
        </p>
      </div>
    </section>
  );
}
